import { CLOSE_NOTIFICATION, NEW_NOTIFICATION, REMOVE_NOTIFICATION } from './types/NotificationTypes';

export const newNotification = (options) => ({
  type: NEW_NOTIFICATION,
  payload: {
    ...options,
  },
});

export const startClosingNotification = ({ id }) => ({
  type: CLOSE_NOTIFICATION,
  payload: {
    id,
    isClosing: true,
  },
});

export function showSuccessNotification(message) {
  return {
    type: NEW_NOTIFICATION,
    payload: {
      text: message,
      type: 'SUCCESS',
    },
  };
}

export function showErrorNotification(message) {
  return {
    type: NEW_NOTIFICATION,
    payload: {
      text: message,
      type: 'ERROR',
    },
  };
}

export const removeNotification = ({ id }) => ({
  type: REMOVE_NOTIFICATION,
  payload: {
    id,
  },
});
